export default "__VITE_ASSET__G4M9tBz___"